import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("selectCalcMethod"),
            field: "calculationProcess",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: 'period',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: "costCenter",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: "project",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension2"),
            field: "dimension2",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension3"),
            field: "dimension3",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension4"),
            field: "dimension4",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension5"),
            field: "dimension5",
            filter: "agTextColumnFilter",
        }
    },

    {
        pages: [paths.historicalDistributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessPorcentaje"),
            field: "percentage",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]